import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { EcrfViewProvider } from './theme/EcrfViewTheme';
import moment from 'moment';
import 'moment/locale/el';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/el';
// Aliased: this project already has its own <App /> component, and antd's App
// is a context provider, not a page. It supplies the modal/message/notification
// instances returned by App.useApp(), which are theme- and locale-aware in a
// way the static Modal.confirm()/message.error() calls are not.
import { ConfigProvider, App as AntdApp } from 'antd';
import el_GR from 'antd/es/locale/el_GR';

dayjs.extend(customParseFormat);
dayjs.extend(LocalizedFormat);
dayjs.locale('el');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
moment().locale('el');

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') ?? "/";
root.render(
  <BrowserRouter basename={baseUrl}>
    <ConfigProvider
      locale={el_GR}
      theme={{
        // Emit the theme as CSS custom properties (--ant-color-primary etc.).
        // The eCRF view stylesheets reference those variables instead of
        // repeating the brand colour, so retheming here reaches them too.
        cssVar: {},
        token: {
          // Primary brand colour, taken from the BIOSTATS logo (measured hue 213°).
          //
          // This replaced a teal #0f9b8e, which was not just a taste change: teal
          // sits at 174° and colorSuccess at 141°, only 33° apart, so the primary
          // "Αποθήκευση" button and the green section-complete tick read as the
          // same signal. Blue separates them to 67°.
          colorPrimary: "#1668b3",
          colorSuccess: "#2d8a4e",
          colorWarning: "#d4880a",
          colorError: "#c0392b",
          colorInfo: "#1668b3",
          colorLink: "#1668b3",

          // Typography
          fontSize: 14,
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,

          // Shape — slightly squared for clinical precision
          borderRadius: 4,
          borderRadiusLG: 6,
          borderRadiusSM: 2,

          // Controls — slightly taller for better touch targets
          controlHeight: 34,

          // Subtle shadow and borders
          boxShadow: "0 1px 3px 0 rgba(0,0,0,0.10), 0 1px 2px 0 rgba(0,0,0,0.06)",
          boxShadowSecondary: "0 4px 6px -1px rgba(0,0,0,0.08), 0 2px 4px -1px rgba(0,0,0,0.04)",
        },
        components: {
          Checkbox: {
            lineWidth: 2,
            colorBgContainer: "#f0f5fa"
          },
          Menu: {
            itemSelectedColor: "#0f589b",
            itemSelectedBg: "#e6eff7",
            itemHoverColor: "#0c4a82",
            itemHoverBg: "#f0f5fa",
          },
          Table: {
            headerBg: "#f0f5fa",
            headerColor: "#1a2b3a",
            rowHoverBg: "#f7fafd",
          },
          Card: {
            headerBg: "#f8fcff",
          },
          Button: {
            borderRadius: 4,
          },
          Badge: {
            colorBgContainer: "#0f589b",
          }
        }
      }}
    >
      <AntdApp>
        <EcrfViewProvider>
          <App />
        </EcrfViewProvider>
      </AntdApp>
    </ConfigProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
